export const AD_CONTENT_LEVELS = Object.freeze({
  AD: 'AD',
  AD_NAME: 'AD_NAME',
  CREATIVE: 'CREATIVE',
} as const);

export type AdContentLevel = (typeof AD_CONTENT_LEVELS)[keyof typeof AD_CONTENT_LEVELS];

export const AdReasonEnum = Object.freeze({
  PLACEMENT: 'PLACEMENT',
} as const);

export const AD_CONTENT_LEVEL_LABELS = Object.freeze({
  [AD_CONTENT_LEVELS.AD]: 'Ads',
  [AD_CONTENT_LEVELS.AD_NAME]: 'Ad Names',
  [AD_CONTENT_LEVELS.CREATIVE]: 'Creatives',
});

export const INVALID_AD_CONTENT = 'INVALID_AD_CONTENT' as const;
